module.exports = __webpack_public_path__ + "img/starting.b6104696.gif";